import { PaginationRequest } from '../config/common';

export class PaginationAddressBookRequest extends PaginationRequest {
    customerID?: string;
  companyName?: string;
  companyNamePostcode?: string;
    postCode?: string;
    id?: string;
    address1?: string;
    address2?: string;
    address3?: string;

}

export interface CreateAddressBookRequest {
  companyName?: string;
  companyNamePostcode?: string;
    address1?: string;
    address2?: string;
    address3?: string;
    town?: string;
    county?: string;
    country?: string;
    postCode?: string;
    phoneNo?: string;
    contactName?: string;
    customerID?: string;
    isDefault?: boolean;
    contactNumber?: string;
    houseNumber?: string;
}
